
import required from './required';

// Clamps a number between min and max
export default function clamp(number = required(), min = 0, max = 100) {
  return number < min ? min : number > max ? max : number;
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/number-clamp.js